var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-skill"},[_c('div',{staticClass:"item-skill__container"},[_c('div',{staticClass:"item-skill__text",domProps:{"innerHTML":_vm._s(_vm.item)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }